import { CaretDown, CaretUp } from 'phosphor-react'
import { useState } from 'react'
import { Collapse } from 'react-collapse'
import { useIntl } from 'react-intl'

type Props = {
  id: string
}

export const AboutUs = ({ id }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const { formatMessage } = useIntl()

  function handleToggleCollpse () {
    setIsExpanded((prevState) => !prevState)
  }

  return (
    <section id={id} className="bg-[#CEE2ED] py-[100px]">
      <div className="px-4 text-justify max-w-[1264px] mx-auto">
        <h2 className="text-2xl md:text-[36px] mb-4 lg:mb-10 text-center uppercase font-openSans text-[#068A8A] font-bold">
          {formatMessage({ id: 'ABOUT_US' })}
        </h2>

        <div className="tracking-[-1.2px] text-[#39393A] text-base md:text-2xl md:leading-9 font-montserrat font-normal">
          <p className="mb-8">
            {formatMessage({ id: 'ABOUT_US_1' })}
          </p>

          <Collapse isOpened={isExpanded}>
            <p className="mb-8">
              {formatMessage({ id: 'ABOUT_US_2' })}
            </p>

            <p className="mb-8">
              {formatMessage({ id: 'ABOUT_US_3' })}
            </p>

            <p>
              {formatMessage({ id: 'ABOUT_US_4' })}
            </p>
          </Collapse>
        </div>

        <button
          type="button"
          className="font-montserrat mt-4 lg:mt-6 lg:text-2xl flex items-center tracking-[-1.2px] gap-2 mx-auto font-semibold text-[#042F49]"
          onClick={handleToggleCollpse}
        >
          {isExpanded ? (
            <>
              {formatMessage({ id: 'SEE_LESS' })}
              <CaretUp color="#042F49" />
            </>
          ) : (
            <>
              {formatMessage({ id: 'KNOW_MORE' })}
              <CaretDown color="#042F49" />
            </>
          )}
        </button>
      </div>
    </section>
  )
}
